// extracted by mini-css-extract-plugin
export var body = "_co-5";
export var closeButton = "_co-f";
export var container = "_co-1";
export var content = "_co-2";
export var cta = "_co-c";
export var ctaLabel = "_co-b";
export var eyebrow = "_co-3";
export var howTo = "_co-6";
export var image = "_co-e";
export var modal = "_co-0";
export var socialButton = "_co-d";
export var stepCard = "_co-8";
export var stepLabel = "_co-a";
export var stepNumber = "_co-9";
export var steps = "_co-7";
export var title = "_co-4";